const seaRouteStyle = { color: "#003366", fill: false };
const landRouteStyle = { color: "#8a0303", fill: false };

export { seaRouteStyle, landRouteStyle };
